import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import getMuiIcon from '../../utils/getMuiIcon';
import { palette, spaces } from '../../assets/styles/themes/tokens';

const EmptyResults: React.FC<{
  primaryText: string;
  secondaryText: string;
}> = ({ primaryText, secondaryText }) => (
  <Stack
    direction='column'
    alignItems='center'
    paddingBottom={spaces.xxl}
  >
    <Box
      component={getMuiIcon('invalidLink')}
      sx={{
        width: '375px',
        height: '300px',
      }}
    />
    <Stack direction='column' alignItems='center' gap={spaces.xs}>
      <Typography variant='h6' color={palette.text.primary}>
        {primaryText}
      </Typography>
      <Typography variant='body2' color={palette.text.secondary}>
        {secondaryText}
      </Typography>
    </Stack>
  </Stack>
);

export default EmptyResults;
